import types from '../types/index';

const reviewsSuccess = (payload) => ({
  type: types.reviews.SET_REVIEWS_SUCCESS,
  payload,
});

const setReviewsError = (payload) => ({
  type: types.reviews.SET_ERRORS_REVIEWS,
  payload,
});

const startFetching = () => ({
  type: types.reviews.START_FETCHING_REVIEWS
});

const stopFetching = () => ({
  type: types.reviews.STOP_FETCHING_REVIEWS,
});

export default {
  reviewsSuccess,
  setReviewsError,
  startFetching,
  stopFetching,
};